import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { I18n, Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import { fetchZones, fetchBins, fetchLevels } from './api';

import axios from 'axios';
import {
  isVAK,
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import { connect } from 'react-redux';

const modalStyle = {
  width: '700px',
  height: '600px',
  marginLeft: '-10%',
  marginTop: '-20%',
}

const propTypes = {
  selectedRows: PropTypes.array,
  onSuccess: PropTypes.func,
}

const defaultProps = {
  onSuccess: () => { },
  selectedRows: [],
}

const prcessZoneData = (zones) => {
  return zones.map(zone => ({
    label: zone.Name,
    description: zone.Description,
    value: zone.id,
  }))
}

const prcessBinData = (bins) => {
  return bins.map(bin => ({
    label: bin.section_num,
    value: bin.id,
  }))
}

const processLevelData = (levels) => {
  return levels.map(level => ({
    label: level.bin_num,
    value: level.id,
    color: level.color,
  }));
}

const initialTableData = {
  rows: [],
  selectedRow: {
    label: '',
    value: '',
  }
}

class RowRenderer extends Component {
  render() {
    return (<div onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }}><ReactDataGrid.Row ref="row" {...this.props} /></div>);
  }
}
const LocationFormatter = connect(state => ({language: state.i18n.locale}))(React.createClass({
  render() {
    const {dependentValues, language} = this.props;
    return <span>{language === 'ch' ? dependentValues.description : dependentValues.label}</span>
  }
}))

class LocationSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // location: props.selectedRows.length ? props.selectedRows[0].Location : '',
      zoneTable: {
        ...initialTableData,
      },
      binTable: {
        ...initialTableData,
      },
      levelTable: {
        ...initialTableData,
      },

    };
  }

  componentDidMount() {
    // const {
    //   selectedWarehouse
    // } = this.props;
    // if (selectedWarehouse.value || selectedWarehouse) {
    //   this.fetchZones();
    // }
    this.fetchZones();
  }

  componentDidUpdate(prevProps, prevState) {
    // const {
    //   selectedWarehouse
    // } = this.props;
    // if (!prevProps.isVisible && this.props.isVisible) {
    //   this.fetchZones();
    // }
  }

  handleConfirmClick = () => {
    const payload = {
      location: this.generateSelectedLocation(),
      color: this.state.levelTable.selectedRow.color,
    };
    if (isVAK) {
      payload.locationDescription = this.generateSelectedLocationDescription();
    }
    this.props.onConfirm(payload);
  }

  fetchZones = () => {
    const {
      selectedWarehouse
    } = this.props;
    const success = (zones) => {
      this.setState({
        zoneTable: {
          ...this.state.zoneTable,
          rows: prcessZoneData(zones),
        }
      });
    }
    let id = selectedWarehouse;
    if (typeof selectedWarehouse === 'object') {
      id = selectedWarehouse.value;
    }
    fetchZones(id, success);
  }

  handleZoneSelect = (row) => {
    this.setState({
      zoneTable: {
        ...this.state.zoneTable,
        selectedRow: row,
      },
      binTable: {
        ...initialTableData,
      },
      levelTable: {
        ...initialTableData,
      },
    });

    const success = (bins) => {
      this.setState({
        binTable: {
          ...this.state.binTable,
          rows: prcessBinData(bins),
        },
      })
    }
    fetchBins(row.value, success)
  }

  handleBinSelect = (bin) => {
    const {
      selectedWarehouse,
      editingLine,
    } = this.props;
    const {
      zoneTable,
      binTable,
    } = this.state;

    this.setState({
      binTable: {
        ...this.state.binTable,
        selectedRow: bin,
      },
      levelTable: {
        ...initialTableData,
      }
    });
    const success = (levels) => {
      this.setState({
        levelTable: {
          ...this.state.levelTable,
          rows: processLevelData(levels),
        }
      })
    }
    // warehouse_id=2&zone_id=7&section_id=66&product_id=54

    const payload = {
      warehouse_id: selectedWarehouse.value || selectedWarehouse,
      zone_id: zoneTable.selectedRow.value,
      section_id: bin.value,
      product_id: editingLine.product_id || editingLine.Product_id,
    }

    fetchLevels(payload, success);
  }

  handleLevelSelect = (level) => {
    this.setState({
      levelTable: {
        ...this.state.levelTable,
        selectedRow: level,
      },
    })
  }

  renderZoneTable = () => {
    const getRows = () => Data.Selectors.getRows(this.state.zoneTable);
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({}, rows[rowIdx]);
    };

    const columns = [{
      key: 'label',
      name: <Translate value="zone" />,
      resizable: true,
      sortable: true,
      // width: 200,
      filterable: true,
      getRowMetaData: row => row,
      formatter: isVAK ? LocationFormatter : undefined
    }];

    return (
      <ReactDataGrid
        rowRenderer={<RowRenderer onDoubleClick={this.handleZoneSelect} />}
        columns={columns}
        rowGetter={rowGetter}
        rowsCount={getSize()}
      />
    )
  }

  renderBinTable = () => {
    const getRows = () => Data.Selectors.getRows(this.state.binTable);
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({}, rows[rowIdx]);
    };

    const columns = [{
      key: 'label',
      name: <Translate value="bin" />,
      resizable: true,
      sortable: true,
      // width: 200,
      filterable: true,
    }];

    return (
      <ReactDataGrid
        rowRenderer={<RowRenderer onDoubleClick={this.handleBinSelect} />}
        columns={columns}
        rowGetter={rowGetter}
        rowsCount={getSize()}
      />
    )
  }

  renderLevelTable = () => {
    const getRows = () => Data.Selectors.getRows(this.state.levelTable);
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({}, rows[rowIdx]);
    };

    const columns = [{
      key: 'label',
      name: <Translate value="level" />,
      resizable: true,
      sortable: true,
      // width: 200,
      filterable: true,
    }];

    return (
      <ReactDataGrid
        rowRenderer={<RowRenderer onDoubleClick={this.handleLevelSelect} />}
        columns={columns}
        rowGetter={rowGetter}
        rowsCount={getSize()}
      />
    )
  }

  generateSelectedLocation = () => {
    const {
      zoneTable,
      binTable,
      levelTable,
    } = this.state;

    let location = '';
    if (zoneTable.selectedRow.value) {
      location = zoneTable.selectedRow.label;
    }
    if (binTable.selectedRow.value) {
      location = `${location}-${binTable.selectedRow.label}`
    }
    if (levelTable.selectedRow.value) {
      location = `${location}-${levelTable.selectedRow.label}`
    }
    return location;
  }

  generateSelectedLocationDescription = () => {
    const {
      zoneTable,
      binTable,
      levelTable,
    } = this.state;

    let location = '';
    if (zoneTable.selectedRow.value) {
      location = I18n._locale === 'ch' ? zoneTable.selectedRow.description : zoneTable.selectedRow.label;
    }
    if (binTable.selectedRow.value) {
      location = `${location}-${I18n._locale === 'ch' ? binTable.selectedRow.description : binTable.selectedRow.label}`
    }
    if (levelTable.selectedRow.value) {
      location = `${location}-${I18n._locale === 'ch' ? levelTable.selectedRow.description : levelTable.selectedRow.label}`
    }
    return location;
  }
  render() {
    let color = `#${this.state.levelTable.selectedRow.color}`;
    if (!this.state.levelTable.selectedRow.color) {
      color = '';
    };
    return (
      <div style={{ width: '100%', height: '100%', padding: '10px' }}>
        <div style={{ display: 'flex', fontSize: isVAK ? '20px' : '40px', flexDirection: 'row', textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ paddingRight: '10px' }}>Selected Location:  </div>
          <div style={{ color: color }}>{isVAK ? this.generateSelectedLocationDescription() : this.generateSelectedLocation()}</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '', border: '1px olid red' }}>
          <div style={{ width: isVAK ? '99.9%' : '33.3%', border: '1px solid green' }}>
            {this.renderZoneTable()}
          </div>
          {!isVAK && <div style={{ width: '33.3%', border: '1px solid green' }}>
            {this.renderBinTable()}
          </div>}
          {!isVAK && <div style={{ width: '33.3%', border: '1px solid green' }}>
            {this.renderLevelTable()}
          </div>}
        </div>
        <div style={{ width: '100%', justifyContent: 'end', alignContent: 'end', textAlign: 'end', alignItems: 'end', paddingTop: '40px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            // disabled={selectedRows.length !== 1}
            onClick={this.handleConfirmClick}
          >
            {/* <em className="fa fa-pencil" /> */}
            <Translate value="confirm" />
          </Button>
        </div>
      </div>
    )
  }
}

const LocationSelectModal = ({ setModalVisibility, isVisible, onConfirm, selectedWarehouse, editingLine }) => (
  <SkyLightStateless
    title={'Location Select'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <LocationSelect onConfirm={onConfirm} selectedWarehouse={selectedWarehouse} editingLine={editingLine} isVisible={isVisible}/>
  </SkyLightStateless>
)

LocationSelectModal.propTypes = propTypes
LocationSelectModal.defaultProps = defaultProps

export default LocationSelectModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/warehouseManagement/LocationSelectModal.jsx